import React from 'react';
import styled from 'astroturf/react';

import { Body } from 'js/design_system/Body';
import { NewsStory, Paper, OpenalexWork } from 'js/social/shared/types';
import ImpressionWatcher, {
  Props as ImpressionProps,
} from 'js/utils/impressions/ImpressionWatcher';
import PaperAbstract from './PaperAbstract';
import _Container from "PaperNewsStory-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/PaperNewsStory.tsx?styleId=Container";
import _ContentAndButtonsContainer from "PaperNewsStory-ContentAndButtonsContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/PaperNewsStory.tsx?styleId=ContentAndButtonsContainer";
import _ContentContainer from "PaperNewsStory-ContentContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/PaperNewsStory.tsx?styleId=ContentContainer";
import _Heading from "PaperNewsStory-Heading.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/PaperNewsStory.tsx?styleId=Heading";
import _NewsBody from "PaperNewsStory-NewsBody.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/PaperNewsStory.tsx?styleId=NewsBody";
import _WorkCardContainer from "PaperNewsStory-WorkCardContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/PaperNewsStory.tsx?styleId=WorkCardContainer";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const ContentAndButtonsContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ContentAndButtonsContainer",
  styles: _ContentAndButtonsContainer
});

const ContentContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ContentContainer",
  styles: _ContentContainer
});

const Heading = /*#__PURE__*/styled(Body, null, {
  displayName: "Heading",
  styles: _Heading
});

const NewsBody = /*#__PURE__*/styled(Body, null, {
  displayName: "NewsBody",
  styles: _NewsBody
});

const WorkCardContainer = /*#__PURE__*/styled("div", null, {
  displayName: "WorkCardContainer",
  styles: _WorkCardContainer
});

type Props = {
  newsStory: NewsStory;
  work: Paper | OpenalexWork;
  canUseReader: boolean;
  showReader: () => void;
  impressionPropsGen: (clickTarget?: string) => ImpressionProps;
  paperInteractions: React.ReactNode;
  variant?: 'default' | 'dense';
};

const PaperStoryContainer: React.FunctionComponent<Props> = ({
  newsStory,
  work,
  canUseReader,
  showReader,
  impressionPropsGen,
  paperInteractions,
  variant = 'default',
}) => {
  const { heading, body } = newsStory;

  const content = (
    <>
      <ContentAndButtonsContainer>
        <ContentContainer variant={variant}>
          <ImpressionWatcher {...impressionPropsGen('story-body')}>
            {heading && (
              <Heading size="md" variant={variant}>
                {heading}
              </Heading>
            )}
            {body && (
              <NewsBody size="md" variant={variant}>
                {body}
              </NewsBody>
            )}
          </ImpressionWatcher>
        </ContentContainer>
        <WorkCardContainer>
          <PaperAbstract
            work={work}
            canUseReader={canUseReader}
            showReader={showReader}
            impressionPropsGen={impressionPropsGen}
            paperInteractions={null}
            size="sm"
            isSnippet={!!newsStory}
            variant={variant}
          />
        </WorkCardContainer>
      </ContentAndButtonsContainer>
    </>
  );

  return (
    <Container variant={variant}>
      {content}
      {paperInteractions}
    </Container>
  );
};

export default PaperStoryContainer;
